import type { ReactNode } from 'react';

export const symbol_line_start_arrow: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M474-229 120-455q-14-9-14-25t14-25l354-226q15-10 30.5-1t15.5 27v195h330q13 0 21.5 8.5T880-480q0 13-8.5 21.5T850-450H520v195q0 18-15.5 27t-30.5-1Zm-14-80v-342L192-480l268 171Zm0-171Z"
		/>
	</svg>
);
